export default {
    bg: require('../assets/images/brushing.bath.jpg'),
    sprites: [{
        image: require('../assets/images/brushing.elephant.png'),
        x: 53,
        y: 50,
        rot: -5,
        scale: .8,
    }, {
        image: require('../assets/images/brushing.deer.png'),
        x: 5,
        y: 50,
        rot: 4,
        scale: .9,
    }, {
        image: require('../assets/images/brushing.toothbrush.png'),
        x: 68,
        y: 45,
        rot: -50,
        scale: .3,
    }, {
        image: require('../assets/images/brushing.toothbrush.png'),
        x: -13,
        y: 45,
        rot: 60,
        scale: .2,
    }],
}